//se src/styles/felles/farger.scss for bruk i css

export const farge_profil_900_hamar = '#031428';
export const farge_profil_800_alta = '#072343';
export const farge_profil_700_oslo = '#06356B';
export const farge_profil_600_gjøvik = '#1E497A';
export const farge_profil_500_bergen = '#1565C0';
export const farge_profil_400_stavanger = '#1E88E5';
export const farge_profil_300_lillesand = '#7EA3DA';
export const farge_profil_200_trondheim = '#D1E6FF';
export const farge_profil_100_fredrikstad = '#F4F9FF';
export const farge_profil_0_hvit = '#FFF';

export const farge_grå_900_loftet = '#0A0A0B';
export const farge_grå_800_galdhøpiggen = '#19191D';
export const farge_grå_700_selemtinden = '#3A3A44';
export const farge_grå_600_glittertind = '#53545F'; //lyseste grå uten å bryte wcag
export const farge_grå_500_storebjørn = '#5A606A';
export const farge_grå_400_skagastølstind = '#787885';
export const farge_grå_300_styggedalstind = '#9696A0';
export const farge_grå_200_skarstind = '#CBCBCF';
export const farge_grå_100_ørneflag = '#F0F0F1';
export const farge_grå_0_hvit = '#FFF';

export const farge_suksess_300_mørk = '#086108';
export const farge_suksess_200_hoved = '#0A870A';
export const farge_suksess_100_lys = '#C1EFC1';

export const farge_advarsel_300_mørk = '#805D01';
export const farge_advarsel_200_hoved = '#F0BC33';
export const farge_advarsel_100_lys = '#FFEAB1';

export const farge_feil_300_mørk = '#7C0E0A';
export const farge_feil_200_hoved = '#CF1D16';
export const farge_feil_100_lys = '#FFB1AE';
